import AppProviders from "./AppProviders";
import AppRoutes from "./AppRoutes";

// App only composes the global providers with the route tree
const App = () => {
    return (
        <div className="App">
            <AppProviders>
                <AppRoutes />
            </AppProviders>
        </div>
    );
};

export default App;